import React from "react";

import { ActivitiesManagementWorkflowType } from "../ActivitiesManagementActions";
import { InformationIcon, UserIcon } from "../../../../components/Icons";

import DialogStyles from "../../../../styles/components/DialogStyles";
import { stylesBoxsModalDetalhes } from "../../../../styles/pages/GestaoFaltas/GestaoFaltas";

const { StyledModalTitle } = DialogStyles;

interface IModalProps {
    workflow: ActivitiesManagementWorkflowType | null;
}

const ActivitiesManagementModalHeader: React.FC<IModalProps> = ({
    workflow,
}) => {
    return (
        <>
            <StyledModalTitle className="mb-3">
                Gestão de Atividades
            </StyledModalTitle>
            <div style={stylesBoxsModalDetalhes.box3}>
                <div style={stylesBoxsModalDetalhes.box4}>
                    <div>
                        <b>
                            <UserIcon
                                style={{ fill: "#8A0538", marginRight: 5 }}
                            />
                            {workflow?.nomeDocente}
                        </b>
                    </div>
                    <div>
                        <b>
                            <InformationIcon
                                style={{ fill: "#8A0538", marginRight: 5 }}
                            />
                            {`Matricula: ${workflow?.matriculaAdp}`}
                        </b>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ActivitiesManagementModalHeader;
